<template lang="html">
  <div class="tabs-mobile-menu">
    <div class="tabs-mobile-menu-header">
      <div v-for="({label, id, count, badge}, index) in items"
        :key="index"
        @click="setActive(id)"
        :class="{'tabs-mobile-menu-header-item': true, 'active-tab': active === id}">
        {{ label }}
        <BadgeCounter v-if="count"
          class="ml-1"
          :count="count"
          :color="badge" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemClass: String,
    hideClass: String | null,
    items: Array,
    native: Boolean
  },

  data: () => ({
    active: ''
  }),

  methods: {
    setActive (id) {
      if (this.native) return this.changeTab(id)

      this.active = id
      document.querySelectorAll('.' + this.itemClass).forEach(ele => {
        if (ele.id === id) ele.classList.remove(this.hideClass || 'hide')
        else ele.classList.add(this.hideClass || 'hide')
      })
    },

    changeTab (id) {
      this.active = id
      this.$emit('tabChanged', id)
    }
  },

  mounted () {
    const first = this.items.find(i => i.default)
    if (first) this.setActive(first.id)
  }
}
</script>

<style lang="scss">
  @import '../../scss/colors';

  .tabs-mobile-menu {
    &-header {
      display: flex;
      width: 100%;
      border-bottom: solid 1px $gray-300;

      &-item {
        flex: 1 0 auto;
        text-align: center;
        padding-top: 1rem;
        padding-bottom: 0.75rem;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        font-weight: bold;
        color: $secondary;

        &.active-tab {
          border-bottom: solid 2px $primary;
          color: $primary;
          font-weight: bold;

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/TabsMenuMobile.vue